<script setup>
import { reactiveOmit } from "@vueuse/core";
import { MenubarLabel } from "reka-ui";
import { cn } from "../../../lib/utils";

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
  inset: { type: Boolean, required: false },
});
const delegatedProps = reactiveOmit(props, "class", "inset");
</script>

<template>
  <MenubarLabel
    data-slot="menubar-label"
    :data-inset="inset ? '' : undefined"
    v-bind="delegatedProps"
    :class="cn('px-1.5 py-1 text-sm font-medium data-inset:pl-7', props.class)"
  >
    <slot />
  </MenubarLabel>
</template>
